import Tippy, { TippyProps } from '@tippyjs/react';
import { Icon } from '../../assets/icons';
import { Item } from '../../buttons/interfaces/Item';
import { TsrSvgIcon } from '../../inputs';
import { ContextMenuComponent } from '../contextMenu/ContextMenuComponent';
import './styles.scss';
import React, { useState } from 'react';
import { CONTEXT_MENU_MAX_WIDTH } from '../contextMenu';

interface IDropdownMenu {
    items: Array<Item>;
    appendTo?: Element | 'parent' | ((ref: Element) => Element) | undefined;
    className?: string;
    onOpen?: () => void;
    setVisiblity?: (visible: boolean) => void;
}

export function DropdownMenu(props: IDropdownMenu & TippyProps) {
    const { items, appendTo, className, children } = props;
    const [open, setOpen] = useState(false);
    const openDropDownHandler = () => {
        props.setVisiblity ? props.setVisiblity(!props.visible) : setOpen(prevOpen => !prevOpen);
    };

    return (
        <Tippy
            onClickOutside={() => {
                props.setVisiblity ? props.setVisiblity(false) : setOpen(false);
            }}
            interactive={true}
            placement={'bottom-end'}
            visible={props.visible !== undefined ? props.visible : open}
            arrow={false}
            appendTo={appendTo}
            offset={[0, 0]}
            duration={0}
            theme={'dropDown'}
            maxWidth={CONTEXT_MENU_MAX_WIDTH}
            onShow={() => props.onOpen?.()}
            content={
                <ContextMenuComponent
                    items={items}
                    onCloseMenu={() => {
                        props.setVisiblity ? props.setVisiblity(false) : setOpen(false);
                    }}
                />
            }
        >
            <div className={`tsr-dropdown-menu ${className || ''}`} onClick={() => openDropDownHandler()}>
                {children}
                <TsrSvgIcon icon={open ? Icon.ArrowUp : Icon.ArrowDown} pointer />
            </div>
        </Tippy>
    );
}
